import React from 'react';

import RenderBodyCopy from '../RenderBodyCopy';

import { CaptionPropTypes } from './Caption.types';

const Caption: React.FC<CaptionPropTypes> = ({ className, bodyCopy }) => {
  return (
    <RenderBodyCopy
      className={`text-body-copy--dark mt-[2rem] text-center leading-[1.8rem] **:text-[1.3rem]! **:font-light! **:not-italic! ${className}`}
      bodyCopy={bodyCopy?.json?.content}
    />
  );
};

export default Caption;
